import api from 'config/api';

export default {
  userTurns: status => api.get(`api/v1/users/turns`, { status }),
  createNewTurn: (slot, form, phone, email, clientNumber) =>
    api.post(`api/v1/users/turns`, {
      working_day_slot_id: slot,
      procedure_name: form,
      phone,
      email,
      client_number: clientNumber
    }),
  updateTurn: (turnId, slotId, form, phone, email, clientNumber) =>
    api.put(`api/v1/users/turns/${turnId}`, {
      working_day_slot_id: slotId,
      procedure_name: form,
      phone,
      email,
      client_number: clientNumber
    }),
  cancelTurn: turnId => api.put(`api/v1/users/turns/${turnId}/cancelation`)
};
